import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import FullStackWebApp from './pages/FullStackWebApp';
import StaticWebsite from './pages/StaticWebsite';
import StaticMobileApp from './pages/StaticMobileApp';
import FullStackMobileApp from './pages/FullStackMobileApp';
import ECommerceWebsite from './pages/ECommerceWebsite';
import ECommerceMobileApp from './pages/ECommerceMobileApp';
import APIDevelopment from './pages/APIDevelopment';
import BackendMicroservices from './pages/BackendMicroservices';
import RealtimeApps from './pages/RealtimeApps';
import CustomDashboards from './pages/CustomDashboards';
import SystemIntegration from './pages/SystemIntegration';
import TechnicalConsulting from './pages/TechnicalConsulting';
import ShopifyDevelopment from './pages/ShopifyDevelopment';
import AIAutomation from './pages/AIAutomation';
import PaymentIntegrations from './pages/PaymentIntegrations';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/service/full-stack-web-app" element={<FullStackWebApp />} />
        <Route path="/service/static-website" element={<StaticWebsite />} />
        <Route path="/service/static-mobile-app" element={<StaticMobileApp />} />
        <Route path="/service/full-stack-mobile-app" element={<FullStackMobileApp />} />
        <Route path="/service/ecommerce-website" element={<ECommerceWebsite />} />
        <Route path="/service/ecommerce-mobile-app" element={<ECommerceMobileApp />} />
        <Route path="/service/api-development" element={<APIDevelopment />} />
        <Route path="/service/backend-microservices" element={<BackendMicroservices />} />
        <Route path="/service/realtime-apps" element={<RealtimeApps />} />
        <Route path="/service/custom-dashboards" element={<CustomDashboards />} />
        <Route path="/service/system-integration" element={<SystemIntegration />} />
        <Route path="/service/technical-consulting" element={<TechnicalConsulting />} />
        <Route path="/service/shopify-development" element={<ShopifyDevelopment />} />
        <Route path="/service/ai-automation" element={<AIAutomation />} />
        <Route path="/service/payment-integrations" element={<PaymentIntegrations />} />
      </Routes>
    </Router>
  );
}

export default App;

